<template>
    <div class="model-build-receipt">
        <Row type="flex" style="align-items: center">
            <div class="flex-child" style="margin-right: 50px">
                <span class="input-label">采购部门： </span>
                <span class="Cascader" v-if="!$route.query.projectId">
                    <Cascader :data="departmentData" v-model="department" @on-change="getCascader"></Cascader>
                </span>
                <span class="Cascader" v-else>
                    {{organName}}
                </span>
            </div>
            <div class="flex-child"  style="margin-right: 50px" v-if="projectStatus !== '1' && quotationStatus === '1'" >
                <span class="input-label" style="min-width: 75px">选择询价单：</span>
                <Select v-model="templateOriginalInfo.quotationNo" filterable clearable @on-change="changeQuotation" style="width: 300px">
                    <Option v-for="(item, index) in quotationList"
                        :key="index"
                        :value="item.quotationNo"
                        :label="item.quotationNo"
                    >
                        <span>{{ item.quotationNo }}</span>
                        <span style="float:right;">{{item.name}}</span>
                    </Option>
                </Select>
            </div>
            <div class="flex-child">
                结算渠道：
                <Select v-model="templateOriginalInfo.settleChannel" style="width:160px;" :disabled="isSt">
                    <Option v-for="item in settleChannelList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                </Select>
            </div>
        </Row>
        <div class="import-model">
            <span class="import-model-span" v-if="modelType === 'model'">
                <Button>导入模板</Button>
                <input type="file" name="files" class="import-input" @change="submitSuccess">
            </span>
            <span class="import-model-span history" v-if="modelType === 'history'">
                <Button @click="idHistoryData = true">引用历史单据</Button>
                <Button type="primary" :loading="addloading" @click="addProduct" v-if="!$route.query.projectId">
                    <span v-if="!addloading">添加物资</span>
                    <span v-else>加载中...</span>
                </Button>
            </span>
        </div>

        <!-- 模板 -->
        <Table :columns="columns" :data="orderData">
            <template slot-scope="{ index }" slot="deletebtn">
                <span class="delete-btn" @click="deleteProduct(index)">删除</span>
            </template>
            <template slot-scope="{ row }" slot="productCount">
                <Input
                    v-model="row.productCount"
                    type="number"
                    @on-change="numberChange(row)"
                    @on-blur="setTotalValue(row)"
                    class="input-number"/>
            </template>
            <template slot-scope="{ row }" slot="unitPrice">
                <Input
                    v-model="row.unitPrice"
                    type="number"
                    :disabled="(row.disabled > 0 || row.type === 2) ? true : false"
                    @on-change="unitPriceChange(row)"
                    @on-blur="setTotalValue(row)"
                    class="input-number"/>
            </template>
            <template slot-scope="{ row }" slot="totalPrice">
                <Input
                    v-model="row.totalPrice"
                    type="number"
                    @on-change="totalPriceChange(row)"
                    @on-blur="setTotalValue(row)"
                    class="input-number"/>
            </template>
        </Table>
         <Row class="table-footer" type="flex" justify="end">
            <div class="monry-detail-info">
                <span>
                    共： <b class="weight"> {{ orderData.length }} </b>项
                </span>
                <span>
                    计： <b class="weight"> {{ templateOriginalInfo.count }} </b>件
                </span>
                <span>
                    合计： <b class="weight"> ￥{{ templateOriginalInfo.priceSum }} </b>元
                </span>
            </div>
        </Row>
        <div class="model-submit-btn">
            <Button type="primary" :loading="loading" :disabled="isDisable">
                <span v-if="!loading" @click="submitModel">确认提交</span>
                <span v-else>正在提交</span>
            </Button>
        </div>

        <Modal
            v-model="idHistoryData"
            class="model-postion-setting"
            title=" ">
            <div class="history-order">
                <span>单号： </span>
                <span class="input">
                    <Input type="text" v-model="historyOrder"></Input>
                </span>
            </div>
            <template slot="footer">
                <span class="his-cancel" @click="idHistoryData = false">取消</span>
                <span class="his-ok" @click="getOriginReceiptDetail">确定</span>
            </template>
        </Modal>
        <!-- 添加物资 -->
        <Modal
            v-model="addDialog"
            class="model-postion-add"
            title="添加物资">
            <div class="table-title">
                <Row type="flex">
                    <div class="boxs-div">
                        <span class="input-label">选择物资分类：</span>
                        <span class="Cascader">
                            <Cascader
                                :data="productClassifyData"
                                v-model="productClassify"
                                @on-change="productClassifyChange"></Cascader>
                        </span>
                    </div>
                    <div class="boxs-div">
                        <span class="input-label">输入物资名称：</span>
                        <span class="Cascader">
                            <Input placeholder="物资名称"
                                v-model="productName"/>
                        </span>
                        <Button
                            type="primary"
                            @click="searchProduct()">
                            搜索
                        </Button>
                    </div>
                </Row>
            </div>
            <div>
                <div class="boxs-div" style="padding: 10px 0">
                    <Button type="primary" @click="addMultipleTerm">批量添加</Button>
                </div>
                <Table
                    :columns="columns1"
                    :data="leftData"
                    :height="380"
                    @on-selection-change="getLeftSelectionChange"
                    ref="leftData">
                    <template slot-scope="{ row }" slot="action">
                        <Button size="small" type="primary" @click="addRightData(row)" v-if="!row._disabled">添加</Button>
                        <!-- <Button size="small" v-else>已添加</Button> -->
                        <span v-else>已添加</span>
                        <Button size="small" @click="cancelAddRightData(row)" v-if="row._disabled" style="margin-left: 4px">移除</Button>
                    </template>
                </Table>
                <div class="pages-footer">
                    <Page
                        :current="productByClassifyVar.pageNumber"
                        :total="leftTotal"
                        :page-size="productByClassifyVar.pageSize"
                        @on-change="getLeftChangePageNum"/>
                </div>
            </div>
            <template slot="footer">
                <span class="his-cancel" @click="cancelAddProduct">取消</span>
                <span class="his-ok" @click="confirmAddProduct">确定</span>
            </template>
        </Modal>
    </div>
</template>

<script>
import { queryProductClassify, queryProductByClassifyNo, createTemplateOriginalInfo, getOriginalByOriginNo, getAllSettleChannel, updateOriginalSync, getOneProject, getProjectSupply, selectQuotationInfoList, getQuotationPrice } from '@/graphql/graphql.js';
import XLSX from 'xlsx';
import { creatMultidimensionalArray } from '@/assets/js/creatArr.js';
import Cookies from 'js-cookie';
import { clone } from '@/assets/js/clone.js';
import { cliqueNoData } from '@/assets/js/data.js';
import NP from 'number-precision';
export default {
    data() {
        return {
            loading: false,
            // 选择采购部门
            department: [],
            departmentData: [],

            // 模板名称， 需要与下载模板的保持一致
            columns: [
                {
                    title: '#',
                    key: 'deletebtn',
                    slot: 'deletebtn',
                    minWidth: 70
                },
                {
                    type: 'index',
                    title: '序号',
                    key: 'index',
                    minWidth: 50
                },
                {
                    title: 'SPU码',
                    key: 'productspu',
                    minWidth: 100,
                    align: 'center'
                },
                {
                    title: '物资名称',
                    key: 'productname',
                    minWidth: 100,
                    align: 'center'
                },
                {
                    title: '物资编码',
                    key: 'productno',
                    minWidth: 100,
                    align: 'center'
                },
                {
                    title: '分类名称',
                    key: 'classifyname',
                    minWidth: 100,
                    align: 'center'
                },
                {
                    title: '分类编码',
                    key: 'classifyno',
                    minWidth: 100,
                    align: 'center'
                },
                {
                    title: '物资规格',
                    key: 'productspectype',
                    minWidth: 100,
                    align: 'center'
                },
                {
                    title: '计量单位',
                    key: 'productspec',
                    minWidth: 100,
                    align: 'center'
                },
                {
                    title: '数量',
                    key: 'productCount',
                    minWidth: 80,
                    align: 'center',
                    slot: 'productCount'
                },
                {
                    title: '单价（元）',
                    key: 'unitPrice',
                    minWidth: 100,
                    align: 'center',
                    slot: 'unitPrice'
                },
                {
                    title: '金额（元）',
                    key: 'totalPrice',
                    minWidth: 100,
                    align: 'center',
                    slot: 'totalPrice'
                }
            ],

            orderData: [],

            templateOriginalInfo: {
                supplierNo: Cookies.getJSON('USER-INFO').supplierNo,
                cliqueNo: Cookies.getJSON('cliqueNo').toString(),
                organNo: '',
                settleChannel: '',
                quotationNo: '',
                serialCount: 0,
                count: 0,
                priceSum: 0
            },
            isDisable: false,
            timeOut: null,

            // 引用历史模板
            idHistoryData: false,
            historyOrder: '',
            settleChannelList: [],
            settleChannel: '',
            // 添加物资
            addDialog: false,
            // 物资分类
            productClassify: [],
            productClassifyData: [],

            // 物资名称
            productName: '',
            // 物资列表查询参数
            productByClassifyVar: {
                pageNumber: 1,
                pageSize: 20,
                classifyNo: '',
                cliqueNo: Cookies.getJSON('cliqueNo').toString(),
                productName: '' // 物资名称
            },
            columns1: [
                {
                    type: 'selection',
                    width: 50,
                    align: 'center'
                },
                {
                    title: '物资名称',
                    key: 'productname',
                    minWidth: 100
                },
                {
                    title: '物资编码',
                    key: 'productspu',
                    minWidth: 120
                },
                {
                    title: '物资分类',
                    key: 'classifyname',
                    minWidth: 120
                },
                {
                    title: '物资规格',
                    key: 'productspectype',
                    minWidth: 100
                },
                {
                    title: '操作',
                    slot: 'action',
                    minWidth: 120
                }
            ],
            leftData: [],
            leftTotal: 0,
            rightData: [],
            leftSelectOptions: [],
            addloading: false,
            receiptInfo: {},
            organName: '',
            isSt: false,
            timerId: null,
            quotationStatus: '',
            projectStatus: '',
            selectQuotation: '',
            quotationList: [],
            quationsData: []
        };
    },

    computed: {
        modelType() {
            const type = this.$route.query.type;
            if (type) {
                return type;
            } else {
                return '';
            }
        }
    },
    beforeDestroy() {
        if (this.timerId) {
            clearTimeout(this.timerId);
        }
    },
    async mounted() {
        const supplierFun = JSON.parse(window.localStorage.getItem('supplierFunction'));
        this.quotationStatus = supplierFun.quotation > -1 ? '1' : '0';
        this.projectStatus = supplierFun.project1 > -1 ? '1' : '0';
        window.sessionStorage.removeItem('receiptList');
        this.getChannelList();
        this.PageInit();
        if (this.$route.query.projectId) {
            this.columns.splice(2, 1);
            this.columns.splice(5, 1);
            this.columns.splice(6, 1);
            this.columns.splice(6, 0, {
                title: '可供应数量',
                key: 'supplyCount',
                minWidth: 100
            });
            this.isSt = true;
        } else {
            this.getDepartmentData();
        }
    },
    methods: {
        // 计划供应
        async getProjectDetail(channel) {
            await this.$apollo.query({
                query: getOneProject,
                context: { useApi1: false },
                variables: {
                    projectId: this.$route.query.projectId
                },
                fetchPolicy: 'network-only'
            }).then(async res => {
                const data = res.data.getOneProject;
                if (data && data.code === 200) {
                    this.receiptInfo = data.data;
                    this.templateOriginalInfo.organNo = this.receiptInfo.organNo;
                    this.templateOriginalInfo.serialCount = this.receiptInfo.totalItem;
                    this.organName = this.receiptInfo.path;
                    channel.forEach(item => {
                        if (item.name === this.receiptInfo.settleChannel) {
                            this.templateOriginalInfo.settleChannel = item.value;
                        }
                    });
                    await this.$apollo.query({
                        query: getProjectSupply,
                        context: { useApi1: false },
                        variables: {
                            projectId: this.$route.query.projectId.toString()
                        },
                        fetchPolicy: 'network-only'
                    }).then(res => {
                        const data = res.data.getProjectSupply;
                        if (data && data.code === 200) {
                            if (data.data.length) {
                                this.orderData = [];
                                this.receiptInfo.items.forEach(item => {
                                    data.data.forEach(sub => {
                                        if (item.productNo === sub.productNo) {
                                            if (sub.supplyCount !== null) {
                                                if (Number(sub.supplyCount) > 0) {
                                                    this.orderData.push({
                                                        serialNum: sub.serialNum,
                                                        productname: sub.productName,
                                                        productno: sub.productNo,
                                                        productspectype: sub.productSpectype,
                                                        classifyname: sub.classifyName,
                                                        productCount: Number(sub.supplyCount).toFixed(3),
                                                        supplyCount: Number(sub.supplyCount).toFixed(3),
                                                        unitPrice: sub.unitPrice1 ? sub.unitPrice1 : sub.unitPrice2,
                                                        totalPrice: sub.unitPrice1 ? Number(NP.round(NP.times(+sub.unitPrice1, +sub.supplyCount), 2)).toFixed(2) : Number(NP.round(NP.times(+sub.unitPrice2, +sub.supplyCount), 2)).toFixed(2),
                                                        disabled: sub.unitPrice1 ? Number(sub.unitPrice1) : Number(sub.unitPrice2)
                                                    });
                                                }
                                            } else {
                                                this.orderData.push({
                                                    serialNum: sub.serialNum,
                                                    productname: sub.productName,
                                                    productno: sub.productNo,
                                                    productspectype: sub.productSpectype,
                                                    classifyname: sub.classifyName,
                                                    productCount: Number(sub.productCount).toFixed(3),
                                                    supplyCount: Number(sub.productCount).toFixed(3),
                                                    unitPrice: sub.unitPrice1 ? sub.unitPrice1 : sub.unitPrice2,
                                                    totalPrice: sub.unitPrice1 ? Number(NP.round(NP.times(+sub.unitPrice1, +sub.productCount), 2)).toFixed(2) : Number(NP.round(NP.times(+sub.unitPrice2, +sub.productCount), 2)).toFixed(2),
                                                    disabled: sub.unitPrice1 ? Number(sub.unitPrice1) : Number(sub.unitPrice2)
                                                });
                                            }
                                        }
                                    });
                                });
                            }
                            if (!this.orderData.length) {
                                this.$setNotice('无可供应数量');
                            }
                            let count = 0;
                            let priceSum = 0;
                            this.orderData.forEach(ele => {
                                count += Number(ele.productCount);
                                priceSum += Number(ele.totalPrice);
                            });
                            this.templateOriginalInfo.serialCount = this.orderData.length;
                            this.templateOriginalInfo.count = count.toFixed(3);
                            this.templateOriginalInfo.priceSum = priceSum.toFixed(2);
                        }
                    }).catch(error => {
                        if (error) {
                            this.$setNotice('服务繁忙，请稍后重试');
                        }
                    });
                }
            }).catch(error => {
                if (error) {
                    this.$setNotice('服务繁忙，请稍后重试');
                }
            });
        },
        // 获取部门列表
        getDepartmentData() {
            clearTimeout(this.timeOut);
            this.departmentData = this.$store.state.organs;
            if (!this.departmentData.length) {
                this.timeOut = setTimeout(() => {
                    this.getDepartmentData();
                }, 1000);
            } else {
                clearTimeout(this.timeOut);
            }
        },
        // 结算渠道
        getChannelList() {
            this.$apollo.query({
                query: getAllSettleChannel,
                variables: {
                    cliqueNo: Cookies.getJSON('cliqueNo').toString(),
                    all: 0
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const result = res.data.getAllSettleChannel;
                result.data.forEach(item => {
                    item.label = item.name;
                    item.value = item.alias;
                });
                this.settleChannelList = result.data;
                if (this.$route.query.projectId) {
                    this.getProjectDetail(result.data);
                } else {
                    this.templateOriginalInfo.settleChannel = result.data[0].alias || '';
                }
            });
        },
        // 上传文件
        submitSuccess(ev) {
            let file = ev.target.files[0];
            const _self = this;
            if (!file) {
                this.$setNotice('模板上传失败');
                return;
            }
            let reader = new FileReader();
            reader.onload = function(e) {
                let data = e.target.result;
                let workbook = XLSX.read(data, {
                    type: 'binary'
                });
                _self.process_wb(workbook);
            };
            reader.readAsBinaryString(file);
            ev.target.value = '';
        },

        // 转换成json数据
        to_json(workbook) {
            let result = {};
            workbook.SheetNames.forEach(sheetName => {
                var roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
                    header: 1
                });
                if (roa.length) result[sheetName] = roa;
            });
            return JSON.stringify(result, 2, 2);
        },

        // 将this抽取 数据处理分离
        process_wb(workbook) {
            let modelArr = '';
            modelArr = JSON.parse(this.to_json(workbook)).Sheet1;
            if (!modelArr) {
                this.$setNotice('请上传标准模板');
                return;
            }
            // 去掉头部， 头部自定义
            let tableHead = modelArr.splice(0, 1);

            // 暂时存放合格数据
            let temporaryArr = [];

            // 控制数据合格， 一旦有不合格数据， 数据不再导入
            let goNext = true;

            // 总和数据
            let count = 0;
            let priceSum = 0;
            modelArr.forEach((ele, key) => {
                // 数量和金额存在且大于0
                if (ele.length > 7) {
                    if (ele[7] !== null && ele[9] !== null) {
                        if (ele[7] && ele[7] > 0 && ele[9] && ele[9] > 0) {
                            temporaryArr.push({
                                productspu: ele[0].toString(),
                                productname: ele[1],
                                productno: ele[2].toString(),
                                classifyname: ele[3],
                                classifyno: ele[4].toString(),
                                productspectype: ele[5],
                                productspec: ele[6],
                                productCount: ele[7] ? Number(ele[7]).toFixed(3) : 0,
                                unitPrice: (Number(ele[9]) / Number(ele[7])).toFixed(2),
                                totalPrice: ele[9] ? Number(ele[9]).toFixed(2) : 0
                            });
                            // 计算总值
                            // count += ele[6];
                            // priceSum += ele[8];
                        } else {
                            goNext = false;
                        }
                    }
                }
            });
            // 计算总值
            temporaryArr.forEach(ele => {
                count += Number(ele.productCount);
                priceSum += Number(ele.totalPrice);
            });
            // 数据合格
            if (goNext) {
                // 合格数据不为空
                if (temporaryArr.length) {
                    // 当前表格没有数据
                    if (!this.orderData.length) {
                        this.orderData = temporaryArr;
                    } else {
                        temporaryArr.forEach(item => {
                            let index = this.orderData.findIndex(ele => {
                                return ele.productno === item.productno && ele.productspectype === item.productspectype;
                            });
                            if (index !== -1) {
                                let nowEle = this.orderData[index];
                                nowEle.productCount = (Number(item.productCount) + Number(nowEle.productCount)).toFixed(3);
                                nowEle.totalPrice = (Number(item.totalPrice) + Number(nowEle.totalPrice)).toFixed(2);
                                nowEle.unitPrice = (Number(nowEle.totalPrice) / Number(nowEle.productCount)).toFixed(2);
                            } else {
                                this.orderData.push(item);
                            }
                        });
                    }
                    this.templateOriginalInfo.serialCount = this.orderData.length;
                    this.templateOriginalInfo.count = (Number(this.templateOriginalInfo.count) + Number(count)).toFixed(3);
                    this.templateOriginalInfo.priceSum = (Number(this.templateOriginalInfo.priceSum) + Number(priceSum)).toFixed(2);
                } else {
                    this.$Notice.open({
                        title: '没有符合数据',
                        duration: 5
                    });
                }
            } else {
                this.$Notice.open({
                    title: '模板不正确',
                    desc: '数量和金额不能为空且大于0',
                    duration: 5
                });
            }
        },

        // 金额 变化
        totalPriceChange(val) {
            if (Number(val.productCount) > 0) {
                if (val.disabled > 0 || val.type === 2) {
                    if (Number(val.productCount) > Number(val.supplyCount)) {
                        val.totalPrice = NP.round(NP.times(+val.unitPrice, +val.productCount), 2);
                    } else {
                        val.productCount = NP.round(NP.divide(+val.totalPrice, +val.unitPrice), 3);
                    }
                } else {
                    if (val.supplyCount && (Number(val.productCount) > Number(val.supplyCount))) {
                        val.totalPrice = NP.round(NP.times(+val.unitPrice, +val.productCount), 2);
                    } else {
                        val.unitPrice = NP.round(NP.divide(+val.totalPrice, +val.productCount), 2);
                    }
                }
                this.orderData[val._index] = val;
            } else {
                val.productCount = 0;
                this.orderData[val._index] = val;
            }
        },

        // 单价 变化
        unitPriceChange(val) {
            if (Number(val.unitPrice) > 0) {
                val.totalPrice = NP.round(NP.times(+val.unitPrice, +val.productCount), 2);
                this.orderData[val._index] = val;
            } else {
                val.unitPrice = 0;
                val.totalPrice = 0;
                this.orderData[val._index] = val;
            }
        },

        // 数量 变化
        numberChange(val) {
            if (Number(val.productCount) > 0) {
                val.totalPrice = NP.round(NP.times(+val.unitPrice, +val.productCount), 2);
                this.orderData[val._index] = val;
            } else {
                val.productCount = 0;
                val.totalPrice = 0;
                this.orderData[val._index] = val;
            }
        },

        // 总计值
        setTotalValue(val) {
            if (this.$route.query.projectId) {
                if (Number(val.supplyCount) > 0) {
                    if (Number(val.productCount) > Number(val.supplyCount)) {
                        val.productCount = val.supplyCount;
                        val.totalPrice = NP.round(NP.times(+val.unitPrice, +val.productCount), 2);
                        this.$setNotice('填写数量应小于可供应数量');
                    }
                } else {
                    this.$setNotice('无可供应数量');
                    val.productCount = 0;
                    val.totalPrice = 0;
                }
            }
            val.productCount = Number(val.productCount).toFixed(3);
            val.unitPrice = Number(val.unitPrice).toFixed(2);
            val.totalPrice = Number(NP.round(NP.times(+val.unitPrice, +val.productCount), 2)).toFixed(2);
            // val.totalPrice = Number(val.totalPrice).toFixed(2);
            let count = 0;
            let priceSum = 0;
            this.orderData.forEach(ele => {
                count += Number(ele.productCount);
                priceSum += Number(ele.totalPrice);
            });
            this.templateOriginalInfo.count = count.toFixed(3);
            this.templateOriginalInfo.priceSum = priceSum.toFixed(2);
        },

        // 获取部门
        getCascader(val) {
            if (val.length && this.projectStatus !== '1' && this.quotationStatus === '1') {
                this.getQuotation(val[val.length - 1]);
                this.selectQuotation = '';
            }
            if (val.length) {
                this.templateOriginalInfo.organNo = val[val.length - 1];
            } else {
                this.templateOriginalInfo.organNo = '';
            }
        },
        // 提交模板
        submitModel() {
            if (!this.templateOriginalInfo.organNo) {
                this.$setNotice('请选择部门');
                return;
            }
            if (this.projectStatus !== '1' && this.quotationStatus === '1' && !this.templateOriginalInfo.quotationNo) {
                this.$setNotice('请选择询价单');
                return;
            }
            this.isDisable = true;
            if (this.orderData.length) {
                // this.loading = true;

                // 克隆数组 && 克隆参数 && 不影响原来数据的情况下
                let finalData = clone(this.orderData);
                let newVar = Object.assign({}, this.templateOriginalInfo);

                finalData.forEach((ele, key) => {
                    ele.serialNum = key + 1;
                    ele.productCount = ele.productCount.toString();
                    ele.unitPrice = ele.unitPrice.toString();
                    ele.totalPrice = ele.totalPrice.toString();
                    ele.productno = ele.productno;
                });
                newVar.originCreateType = 1;
                newVar.projectId = this.$route.query.projectId;
                newVar.count = newVar.count;
                newVar.priceSum = newVar.priceSum;
                newVar.templateoriginalItemsInput = finalData;
                newVar.templateoriginalItemsInput.forEach(ele => {
                    delete ele._index;
                    delete ele._rowKey;
                    delete ele.disabled;
                    delete ele.supplyCount;
                });
                if (this.quotationStatus !== '1') {
                    delete newVar.quotationNo;
                }
                const arr = newVar.templateoriginalItemsInput;
                const newArr = arr.map(item => item.productno);
                const isRepeat = newArr.some((item, index, arr) => arr.indexOf(item) !== index);
                let adopt = true;
                newVar.templateoriginalItemsInput.forEach(ele => {
                    if (Number(ele.productCount) <= 0 || Number(ele.totalPrice) <= 0 || Number(ele.unitPrice) <= 0) {
                        adopt = false;
                    }
                });
                if (adopt) {
                    if (!isRepeat) {
                        this.$apollo.mutate({
                            mutation: createTemplateOriginalInfo,
                            variables: {
                                templateOriginalInfo: newVar
                            }
                        }).then(res => {
                            this.loading = false;
                            const data = res.data.createTemplateOriginalInfo;
                            if (data && data.code === 200) {
                                this.orderData = [];
                                setTimeout(() => {
                                    this.isDisable = false;
                                }, 1000);
                                this.isDisable = true;
                                this.$setNotice('上传成功');
                                this.$Notice.open({
                                    title: '提交成功',
                                    desc: '订单号： ' + data.data,
                                    duration: 30
                                });
                                if (this.$route.query.type === 'model') {
                                    const cliqueNo = cliqueNoData;
                                    const isClique = cliqueNo.indexOf(Cookies.getJSON('cliqueNo').toString()) > -1;
                                    if (isClique) {
                                        this.$apollo.mutate({
                                            mutation: updateOriginalSync,
                                            variables: {
                                                originNo: data.data
                                            }
                                        }).then(res => {
                                            const data = res.data.updateOriginalSync;
                                            if (data && data.code === 200) {
                                                this.$router.push('/index/receiptsList');
                                            } else {
                                                this.$Notice.open({
                                                    title: '提示',
                                                    desc: data.message,
                                                    duration: 10
                                                });
                                            }
                                        }).catch(error => {
                                            if (error) {
                                                this.$setNotice('服务繁忙，同步失败');
                                            }
                                        });
                                    } else {
                                        this.$router.push('/index/receiptsList');
                                    }
                                } else {
                                    this.$router.push('/index/receiptsList');
                                }
                            } else {
                                this.isDisable = false;
                                this.$Notice.open({
                                    title: '提交失败',
                                    desc: data.message
                                });
                            }
                        }).catch(error => {
                            this.loading = false;
                            this.isDisable = false;
                            if (error) {
                                this.$setNotice('服务繁忙，请稍后重试');
                            }
                        });
                    } else {
                        this.loading = false;
                        this.isDisable = false;
                        this.$setNotice('有重复物资！');
                    }
                } else {
                    this.$setNotice('数量/单价/金额不能为0');
                    this.isDisable = false;
                }
            } else {
                this.$setNotice('您还没有上传模板');
                this.isDisable = false;
            }
        },
        // 添加物资
        addProduct() {
            this.addloading = true;
            this.getProductClassify();
            this.getProductByClassifyNo();
            this.timerId = setTimeout(() => {
                this.addloading = false;
                this.addDialog = true;
            }, 2000);
        },
        cancelAddProduct() {
            this.leftSelectOptions = [];
            this.rightData = [];
            this.$refs.leftData.selectAll(false);
            this.addDialog = false;
        },
        confirmAddProduct() {
            const newArr = [];
            if (this.quationsData.length) {
                this.quationsData.forEach(sub => {
                    this.rightData.forEach(item => {
                        item.totalPrice = 0;
                        item.productCount = 0;
                        if (sub.productNo === item.productno) {
                            item.unitPrice = sub.price;
                            item.disabled = Number(item.unitPrice);
                            item.type = 2;
                        } else {
                            item.unitPrice = '';
                            item.disabled = 0;
                            item.type = 1;
                        }
                    });
                });
            } else {
                this.rightData.forEach(item => {
                    item.totalPrice = '';
                    item.productCount = '';
                    item.unitPrice = '';
                    item.disabled = 0;
                    item.type = 1;
                });
            }
            this.rightData.forEach(item => {
                newArr.push({
                    classifyname: item.classifyname,
                    classifyno: item.classifyno,
                    productname: item.productname,
                    productno: item.productno,
                    productspectype: item.productspectype,
                    productspec: item.productunit,
                    productspu: item.productspu,
                    totalPrice: item.totalPrice,
                    productCount: item.productCount,
                    unitPrice: item.unitPrice,
                    type: item.type
                });
            });
            const arr = this.orderData.concat(newArr);
            const uniqueName = this.unique(arr);
            this.orderData = uniqueName;
            let count = 0;
            let priceSum = 0;
            this.orderData.forEach(ele => {
                count += Number(ele.productCount); // 件数
                priceSum += Number(ele.totalPrice); // 总金额
            });
            this.templateOriginalInfo.serialCount = this.orderData.length;
            this.templateOriginalInfo.count = count.toFixed(3);
            this.templateOriginalInfo.priceSum = priceSum.toFixed(2);
            this.addDialog = false;
        },
        unique(arr) {
            let find = [];
            arr.forEach(el => {
                if (!find.find(e => e.productno === el.productno)) {
                    find.push(el);
                }
            });
            return find;
        },
        addMultipleTerm() {
            if (this.leftSelectOptions.length) {
                this.rightData = this.rightData.concat(this.leftSelectOptions);
                this.leftData.forEach(ele => {
                    let leftIndex = this.rightData.findIndex(item => {
                        return item.productno === ele.productno;
                    });
                    if (leftIndex !== -1) {
                        ele._disabled = true;
                    } else {
                        ele._disabled = false;
                    }
                    if (this.orderData.length) {
                        this.orderData.forEach(sub => {
                            if (ele.productno === sub.productno) {
                                ele._disabled = true;
                            }
                        });
                    }
                });
                // 取消全选
                this.$refs.leftData.selectAll(false);
            } else {
                this.$setNotice('没有要添加的物资');
            }
        },
        getLeftSelectionChange(selects) {
            this.leftSelectOptions = selects;
        },
        addRightData(rows) {
            if (this.leftSelectOptions.length) {
                this.$refs.leftData.selectAll(false);
            }
            let addItem = Object.assign({}, this.leftData[rows._index]);
            this.leftData[rows._index]._disabled = true;
            this.rightData.push(addItem);
        },
        cancelAddRightData(rows) {
            this.leftData[rows._index]._disabled = false;
            this.rightData.splice(rows._index, 1);
            this.orderData.forEach((item, idx) => {
                if (rows.productno === item.productno) {
                    this.orderData.splice(idx, 1);
                }
            });
        },
        getLeftChangePageNum(val) {
            this.productByClassifyVar.pageNumber = val;
            this.getProductByClassifyNo();
        },
        // 选中物资分类
        productClassifyChange(val) {
            this.productName = '';
            this.productByClassifyVar.productName = '';
            this.productByClassifyVar.classifyNo = val[val.length - 1] || '';
        },
        // 获取物资分类的联级列表
        getProductClassify() {
            this.$apollo.query({
                query: queryProductClassify,
                variables: {
                    cliqueNo: `${Cookies.getJSON('cliqueNo')}`,
                    supplierNo: `${Cookies.getJSON('USER-INFO').supplierNo}`
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.queryProductClassify;
                if (data && data.data && data.code === 200) {
                    let parentData = [];
                    for (let i = 5;i > 0;i -= 1) {
                        if (data.data[i.toString()].length) {
                            parentData = creatMultidimensionalArray(
                                data.data[i.toString()],
                                parentData,
                                'classifyParentNo',
                                'classifyName',
                                'classifyNo'
                            );
                        } else {
                            continue;
                        }
                    }
                    parentData.forEach(ele => {
                        let classifyName, classifyNo, children, value, label;
                        ({ classifyName: label, classifyNo: value, children } = ele);
                        this.productClassifyData.push({
                            value,
                            label,
                            children
                        });
                    });
                } else {
                    this.$setNotice('分类列表获取失败，刷新试试吧');
                }
            });
        },
        // 获取物资列表
        getProductByClassifyNo() {
            this.$apollo.query({
                query: queryProductByClassifyNo,
                variables: this.productByClassifyVar,
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.queryProductByClassifyNo;
                if (data && data.data && data.code === 200) {
                    this.$Notice.destroy();
                    data.data.forEach(ele => {
                        ele._disabled = false;
                        this.orderData.forEach(sub => {
                            if (ele.productno === sub.productno) {
                                ele._disabled = true;
                            }
                        });
                    });
                    this.leftTotal = data.count;
                    this.leftData = data.data;
                } else {
                    this.$setNotice('物资列表获取失败，刷新试试吧');
                }
            });
        },
        searchProduct() {
            this.productByClassifyVar.pageNumber = 1;
            this.productByClassifyVar.productName = this.productName;
            this.getProductByClassifyNo();
        },
        // 删除物资
        deleteProduct(index) {
            let count = 0;
            let priceSum = 0;
            this.orderData.splice(index, 1);
            this.orderData.forEach(ele => {
                count += Number(ele.productCount); // 件数
                priceSum += Number(ele.totalPrice); // 总金额
            });
            this.templateOriginalInfo.serialCount = this.orderData.length;
            this.templateOriginalInfo.count = count.toFixed(3);
            this.templateOriginalInfo.priceSum = priceSum.toFixed(2);
        },

        // 根据单据查询历史
        getOriginReceiptDetail() {
            if (!this.historyOrder) {
                this.$setNotice('单号不能为空');
            } else {
                this.getHistoryOrderData(this.historyOrder);
            }
        },

        // 根据单据查询历史
        getHistoryOrderData(origin) {
            const clique = Cookies.getJSON('cliqueNo');
            this.$apollo.query({
                query: getOriginalByOriginNo,
                variables: {
                    cliqueNo: clique.toString(),
                    originNo: origin
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                this.loading = false;
                const data = res.data.getOriginalByOriginNo;
                if (data && data.code === 200) {
                    this.idHistoryData = false;
                    if (this.projectStatus !== '1' && this.quotationStatus === '1') {
                        if (!this.templateOriginalInfo.quotationNo) {
                            this.getQuotationPrice(data.data.items, data.data.quotationNo);
                        } else {
                            this.getQuotationPrice(data.data.items, this.templateOriginalInfo.quotationNo);
                        }
                    } else {
                        let newOrderData = [];
                        data.data.items.forEach(element => {
                            if (this.$route.query.projectId) {
                                if (element.supplyCount !== null) {
                                    element.productCount = Number(element.supplyCount).toFixed(3);
                                    element.totalPrice = Number(NP.round(NP.times(+element.unitPrice, +element.supplyCount), 2)).toFixed(2);
                                    element.supplyCount = Number(element.supplyCount).toFixed(3);
                                } else {
                                    element.productCount = element.productCount;
                                    element.totalPrice = Number(NP.round(NP.times(+element.unitPrice, +element.productCount), 2)).toFixed(2);
                                    element.supplyCount = element.productCount;
                                }
                            }
                            newOrderData.push({
                                productspu: element.spu,
                                productname: element.productName,
                                productno: element.productNo,
                                classifyname: element.classifyName,
                                classifyno: element.classifyNo,
                                productspectype: element.productSpectype,
                                productspec: element.productUnit,
                                productCount: element.productCount,
                                unitPrice: element.unitPrice,
                                totalPrice: element.totalPrice,
                                disabled: element.price2 ? Number(element.price2) : Number(element.price1),
                                supplyCount: element.supplyCount,
                                type: element.type
                            });
                        });
                        let count = 0;
                        let priceSum = 0;
                        newOrderData.forEach(ele => {
                            count += Number(ele.productCount); // 件数
                            priceSum += Number(ele.totalPrice); // 总金额
                        });
                        this.orderData = newOrderData;
                        this.templateOriginalInfo.serialCount = this.orderData.length;
                        this.templateOriginalInfo.count = count.toFixed(3);
                        this.templateOriginalInfo.priceSum = priceSum.toFixed(2);
                    }
                } else {
                    this.$setNotice(data.message);
                }
            });
        },
        // 获取询价单
        getQuotation(v) {
            this.$apollo.query({
                query: selectQuotationInfoList,
                context: { useApi1: false },
                variables: {
                    condi: {
                        name: '',
                        supplierNo: Cookies.getJSON('USER-INFO').supplierNo,
                        state: 1,
                        organ: v
                    },
                    cliqueNo: Cookies.getJSON('cliqueNo').toString()
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.selectQuotationInfoList;
                if (data && data.code === 200) {
                    if (!data.data.length) {
                        this.$setNotice('暂无询价单');
                    } else {
                        this.quotationList = data.data;
                    }
                } else {
                    this.$setNotice(data.message);
                }
            });
        },
        getQuotationPrice(arr, id) {
            this.$apollo.query({
                query: getQuotationPrice,
                context: { useApi1: false },
                variables: {
                    quotationNo: id
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.getQuotationPrice;
                if (data && data.code === 200) {
                    let newOrderData = [];
                    this.quationsData = data.data;
                    arr.forEach(item => {
                        item.productNo = item.productno || item.productNo;
                        item.type = 1;
                        if (data.data.length) {
                            data.data.forEach(last => {
                                if (last.productNo === item.productNo) {
                                    item.unitPrice = last.price;
                                    item.totalPrice = Number(NP.round(NP.times(+last.unitPrice, +last.productCount), 2)).toFixed(2);
                                    item.disabled = Number(item.unitPrice);
                                    item.type = 2;
                                }
                            });
                        } else {
                            item.unitPrice = '';
                            item.totalPrice = '';
                            item.disabled = 0;
                            item.type = 1;
                        }
                        if (item.spu) {
                            newOrderData.push({
                                productspu: item.spu,
                                productname: item.productName,
                                productno: item.productNo,
                                classifyname: item.classifyName,
                                classifyno: item.classifyNo,
                                productspectype: item.productSpectype,
                                productspec: item.productUnit,
                                productCount: item.productCount,
                                unitPrice: item.unitPrice,
                                totalPrice: Number(NP.round(NP.times(+item.unitPrice, +item.productCount), 2)).toFixed(2),
                                disabled: item.disabled,
                                type: item.type
                            });
                        } else {
                            newOrderData.push({
                                productspu: item.productspu,
                                productname: item.productname,
                                productno: item.productno,
                                classifyname: item.classifyname,
                                classifyno: item.classifyno,
                                productspectype: item.productspectype,
                                productspec: item.productspec,
                                productCount: item.productCount,
                                unitPrice: item.unitPrice,
                                totalPrice: Number(NP.round(NP.times(+item.unitPrice, +item.productCount), 2)).toFixed(2),
                                disabled: item.disabled,
                                type: item.type
                            });
                        }
                    });
                    let count = 0;
                    let priceSum = 0;
                    newOrderData.forEach(ele => {
                        count += Number(ele.productCount); // 件数
                        priceSum += Number(ele.totalPrice); // 总金额
                    });
                    this.orderData = newOrderData;
                    this.templateOriginalInfo.serialCount = this.orderData.length;
                    this.templateOriginalInfo.count = count.toFixed(3);
                    this.templateOriginalInfo.priceSum = priceSum.toFixed(2);
                }
            });
        },
        changeQuotation(data) {
            if (data && this.orderData) {
                this.getQuotationPrice(this.orderData, data);
            }
        },
        // 页面初始化
        PageInit() {
            const origin = this.$route.query.origin;
            if (origin) {
                this.getHistoryOrderData(origin);
            }
        }
    }
};
</script>

<style lang="stylus">

@import '../assets/stylus/views/model-build.styl'

</style>



// WEBPACK FOOTER //
// src/views/ModelBuildReceipt.vue